<template>
  <section class="gt-page">
    <div class="gt-page-inner">
      <div class="header-row">
        <div>
          <span class="gt-pill">Sistema</span>
          <h1>Vendedores</h1>
          <p class="gt-muted">Solo un administrador de sistema puede crear vendedores. No hay registro publico para este rol.</p>
        </div>
      </div>

      <div class="gt-grid cols-2">
        <form class="gt-card form-card" @submit.prevent="createSeller">
          <h2>Nuevo vendedor</h2>
          <label class="gt-label">Nombre</label>
          <input v-model.trim="form.name" class="gt-input" type="text" />
          <label class="gt-label">Correo</label>
          <input v-model.trim="form.email" class="gt-input" type="email" />
          <label class="gt-label">Nombre comercial</label>
          <input v-model.trim="form.display_name" class="gt-input" type="text" />
          <label class="gt-label">Contrasena inicial</label>
          <input v-model="form.password" class="gt-input" type="password" placeholder="Opcional, minimo 8" />
          <button class="gt-button primary" :disabled="loading">Crear vendedor</button>
          <p v-if="message" class="message">{{ message }}</p>
          <p v-if="error" class="error">{{ error }}</p>
        </form>

        <div class="gt-card list-card">
          <h2>Registrados</h2>
          <button class="gt-button soft" @click="loadSellers">Actualizar</button>
          <div v-if="createdUrl" class="created-url">
            <strong>Link generado:</strong>
            <code>{{ createdUrl }}</code>
          </div>
          <article v-for="seller in sellers" :key="seller.seller_code" class="seller-item">
            <strong>{{ seller.display_name }}</strong>
            <span>{{ seller.email }}</span>
            <code>{{ seller.seller_code }}</code>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'SellersView',
  data() {
    return {
      sellers: [],
      loading: false,
      error: '',
      message: '',
      createdUrl: '',
      form: { name: '', email: '', display_name: '', password: '' },
    };
  },
  mounted() { this.loadSellers(); },
  methods: {
    async loadSellers() {
      try {
        const { data } = await api.get('/api/admin/sellers');
        this.sellers = data.sellers || [];
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudieron cargar vendedores.';
      }
    },
    async createSeller() {
      this.loading = true;
      this.error = '';
      this.message = '';
      this.createdUrl = '';
      try {
        const { data } = await api.post('/api/admin/sellers', this.form);
        this.message = data.message;
        this.createdUrl = data.seller?.registration_url;
        this.form = { name: '', email: '', display_name: '', password: '' };
        await this.loadSellers();
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudo crear vendedor.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-row { margin-bottom: 1.5rem; }
h1 { margin: .8rem 0 .3rem; font-size: 2.4rem; }
.form-card, .list-card { padding: 1.5rem; }
.form-card { display: grid; gap: .75rem; }
.seller-item { display: grid; gap: .25rem; border-top: 1px solid var(--gt-border); padding: 1rem 0; }
.seller-item span { color: var(--gt-muted); }
code { background: var(--gt-primary-soft); padding: .25rem .5rem; border-radius: 8px; width: fit-content; }
.created-url { margin: 1rem 0; display: grid; gap: .4rem; }
.message { color: var(--gt-success); font-weight: 800; }
.error { color: var(--gt-danger); font-weight: 800; }
</style>
